import { render } from "./AddClient.vue?vue&type=template&id=b111e6a2&scoped=true"
import script from "./AddClient.vue?vue&type=script&lang=js"
export * from "./AddClient.vue?vue&type=script&lang=js"

import "./AddClient.vue?vue&type=style&index=0&id=b111e6a2&lang=scss&scoped=true"

import exportComponent from "/Users/yalemarc/Documents/yaleapps/simplify-photo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b111e6a2"]])

export default __exports__